import {
    Configuration,
    // MetadataTable,
    TableContextResponse,
    TableControllerApi,
    TableDataResponse,
    TableDto,
    Vector,
} from "@inode/pilot-client-typescript-fetch";
import { ApplicationState } from "#store/types";
import { baseCfg } from "#services/pilotService/baseCfg";

export class PilotTableService {
    private api: TableControllerApi;
    private url: string;
    private config: Configuration;
    private userId: string;

    constructor(url: string, userId: string) {
        this.url = url;
        this.userId = userId;
        this.config = new Configuration(baseCfg(url, userId));
        this.api = new TableControllerApi(this.config);
    }

    /**
     * retrieves a list of keys to identify available tables
     */
    list(): Promise<number[]> {
        return this.api
            .listTables({
                X_Reference_ID: this.userId,
            })
            .then(resp => {
                return Promise.resolve(resp.map(x => x.id));
            })
            .catch(err => {
                console.log("Failed to list tables", err);
                return Promise.reject(err);
            });
    }

    // getTableData(tableId: number): Promise<TableDataResponse> {
    getTableData(tableId: number): Promise<any> {
        return this.api
            .getTableData({
                id: tableId,
                X_Reference_ID: this.userId,
            })
            .then(resp => {
                return Promise.resolve(resp);
            })
            .catch(err => {
                console.log("Failed to fetch table", err);
                return Promise.reject(err);
            });
    }

    getTable(tableId: number): Promise<TableDto> {
        return this.api
            .getTable({
                id: tableId,
                X_Reference_ID: this.userId,
            })
            .then(resp => {
                return Promise.resolve(resp);
            })
            .catch(err => {
                console.log("Failed to fetch table", err);
                return Promise.reject(err);
            });
    }

    context(tables: number[], query?: string): Promise<TableContextResponse> {
        console.log("query for tables", tables);
        return this.api
            .getContext({
                X_Reference_ID: this.userId,
                TableContextRequest: {
                    query,
                    tables,
                },
            })
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(err => {
                console.log("Failed to fetch context", err);
                return Promise.reject(err);
            });
    }

    getProjection(tableIds: number[]): Promise<Vector[]> {
        return this.api
            .getContextProjection({
                X_Reference_ID: this.userId,
                request_body: tableIds,
            })
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(err => {
                console.warn("Failed to fetch projection", err);
                return Promise.reject(err);
            });
    }

    fetchVectorForTable(tableId: number): Promise<number[]> {
        console.log("querying vectors");
        return this.api
            .getTableVector({
                X_Reference_ID: this.userId,
                id: tableId,
            })
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(err => {
                console.log("Failed to fetch vector for id", tableId, err);
                return Promise.reject(err);
            });
    }
}
